import React from "react";

export default React.createContext({
    dateType: "",
    setDateType: () => {},
    dates: {},
    setDates: () => {},
    pricelists: null,
    subCategories: null,
    loading: {},
    statsCA: {},
    statsSales: {},
    statsPayments: {},
    statsVats: {},
    statsPricelists: {},
    statsCategories: {},
    statsSubCategories: {},
    statsProducts: {}
})
